import { sumBy, times } from 'lodash';
import { useHistory } from 'react-router-dom';
import React from 'react';
import { PAYMENT_METHOD } from '../../../preorder/containers/CheckoutPage/components/Checkout';
import { useProgressContext } from '../../../preorder/contexts/useProgressContext';
import VoucherShopItemCheckoutModal from '../../components/coupon/VoucherShopItemCheckoutModal';
import { useCouponStoreContext } from '../../contexts/coupon';
import preOrderAPI from '../../../preorder/api/preOrder';
import { useAuthState } from '../../../preorder/plugins/Auth';
import { paymentMethodMap } from '../../../menu/containers/PreOrder';
import { voucherShopCheckout } from '../../api/coupon';

export default ({
  id,
  isOpen,
  onCancelButtonClick,
}) => {
  const history = useHistory();
  const { voucherShopItemDict, isLoading } = useCouponStoreContext();
  const { [id]: voucherShopItem } = voucherShopItemDict;
  const { start: startProgress, end: endProgress } = useProgressContext();
  const { token } = useAuthState();

  const onCheckoutButtonClick = async (data) => {
    const { paymentInfo, paymentMethod, buyCount } = data || {};

    startProgress();

    try {
      if (!paymentMethod) throw new Error('請選擇支付方式');

      const items = times(buyCount, () => ({ voucherShopItemId: id }));
      const totalPrice = sumBy(items, (item) => {
        const { voucherShopItemId } = item || {};
        const { [voucherShopItemId]: { price } = {} } = voucherShopItemDict || {};

        return price || 0;
      });

      if (paymentMethod === PAYMENT_METHOD.LINE_PAY) {
        const result = await preOrderAPI.createLinePayRequestInfo({
          body: {
            token,
            linePayRedirectUrl: `${window.location.origin}/pre-orders/checkout/line-pay-payment?submitLinePay=true`,
            preChargeAmount: totalPrice,
          },
        });

        const { status, redirectUrl } = result || {};

        if (status !== 'OK') throw new Error('LINE PAY 交易失敗，請聯繫客人員。');
        if (!redirectUrl) throw new Error('LINE PAY 交易失敗，請聯繫客人員。');

        window.localStorage.setItem('checkoutSummary', JSON.stringify({
          from: 'voucherShopCheckout',
          items,
          totalPrice,
        }));

        const { search, pathname, origin: redirectOrigin } = new URL(redirectUrl);

        if (window.location.origin === redirectOrigin) {
          history.replace(`${pathname}${search}`);

          endProgress();

          return false;
        }

        window.location.href = redirectUrl;

        return false;
      }

      const checkoutResult = await voucherShopCheckout({
        items,
        paymentInfo,
        paymentMethod: paymentMethodMap[paymentMethod],
        token,
      });
      const { status, message } = checkoutResult || {};

      if (status !== 'success') throw new Error(message || '結帳失敗，請聯繫客人員。');

      history.replace({
        state: {
          showCheckoutCompletedDialog: true,
        },
      });

      history.go(0);

      endProgress();
      return true;
    } catch (e) {
      endProgress();
      throw e;
    }
  };

  return (
    <VoucherShopItemCheckoutModal
      data={voucherShopItem || {}}
      isLoading={isLoading}
      isOpen={isOpen}
      onCheckoutButtonClick={onCheckoutButtonClick}
      onClose={onCancelButtonClick}
    />
  );
};
